import React, {useState, useEffect} from "react";
import Head from "next/head";
import * as Text from "@/components/text";
import { Nav } from "@/components/navigation/Navbar";
import qs from "qs";
import apiClient from "@/utils/apiClient";
import { getStrapiImage } from "@/utils/strapiFunctions";
import Filter, { MobileFilter } from "@/components/forms/Filter";
import { useInitiatives } from "@/actions/useInitiativeSearch";
import { XIcon } from "@heroicons/react/solid";
import { localeTexts} from "@/utils/locale";

const mexicanStates = [
  { id: 0, name: "Aguascalientes", value: "AGUASCALIENTES" },
  { id: 1, name: "Baja California", value: "BAJA CALIFORNIA" },
  { id: 2, name: "Baja California Sur", value: "BAJA CALIFORNIA SUR" },
  { id: 3, name: "Campeche", value: "CAMPECHE" },
  { id: 4, name: "Chiapas", value: "CHIAPAS" },
  { id: 5, name: "Chihuahua", value: "CHIHUAHUA" },
  { id: 6, name: "Ciudad de México", value: "CIUDAD DE MEXICO" },
  { id: 7, name: "Coahuila", value: "COAHUILA" },
  { id: 8, name: "Colima", value: "COLIMA" },
  { id: 9, name: "Durango", value: "DURANGO" },
  { id: 10, name: "Estado de México", value: "ESTADO DE MEXICO" },
  { id: 11, name: "Guanajuato", value: "GUANAJUATO" },
  { id: 12, name: "Guerrero", value: "GUERRERO" },
  { id: 13, name: "Hidalgo", value: "HIDALGO" },
  { id: 14, name: "Jalisco", value: "JALISCO" },
  { id: 15, name: "Michoacán", value: "MICHOACAN" },
  { id: 16, name: "Morelos", value: "MORELOS" },
  { id: 17, name: "Nayarit", value: "NAYARIT" },
  { id: 18, name: "Nuevo León", value: "NUEVO LEON" },
  { id: 19, name: "Oaxaca", value: "OAXACA" },
  { id: 20, name: "Puebla", value: "PUEBLA" },
  { id: 21, name: "Querétaro", value: "QUERETARO" },
  { id: 22, name: "Quintana Roo", value: "QUINTANA ROO" },
  { id: 23, name: "San Luis Potosí", value: "SAN LUIS POTOSI" },
  { id: 24, name: "Sinaloa", value: "SINALOA" },
  { id: 25, name: "Sonora", value: "SONORA" },
  { id: 26, name: "Tabasco", value: "TABASCO" },
  { id: 27, name: "Tamaulipas", value: "TAMAULIPAS" },
  { id: 28, name: "Tlaxcala", value: "TLAXCALA" },
  { id: 29, name: "Veracruz", value: "VERACRUZ" },
  { id: 30, name: "Yucatán", value: "YUCATAN" },
  { id: 31, name: "Zacatecas", value: "ZACATECAS" },
];

export default function Aliados({ partnerstBlocks, locale }) {
  const partnersRef = React.useRef([...partnerstBlocks]);
  const [partners, setPartners] = React.useState(partnerstBlocks);
  // const [partnersData, setPartnersData] = useState(partnerstBlocks);
  const { data: initiativesFilters, error: initiativesFiltersError } =
    useInitiatives();

  const clearFilters = () => {
    setInitiatives([]);
    setSelectedStates([]);
    setPartners(partnersRef.current);
  };

  const filters = initiativesFilters?.data?.map((i) => ({
    name: i.attributes.name,
    value: i.attributes.slug,
  }));

  const [initiatives, setInitiatives] = React.useState([]);
  const [selectedStates, setSelectedStates] = React.useState([]);

  React.useEffect(() => {
    if (initiatives.length > 0) {
      let newPartners = partnersRef.current.map((p) => {
        let newP = { ...p };
        let aliadosData = p?.aliados?.data?.filter((aliado) => {
          return initiatives.includes(
            aliado?.attributes?.iniciativas?.data[0]?.slug
          );
        });
        newP.aliados.data = aliadosData ? p.aliados.data : [];
        return newP;
      });
      setPartners(newPartners);
    } else {
      setPartners(partnersRef.current);
    }
  }, [initiatives]);

  React.useEffect(() => {
    if (selectedStates.length > 0) {
      let newPartners = partnersRef.current.map((p) => {
        let newP = { ...p };
        let aliadosData = p?.aliados?.data?.filter((aliado) => {
          const states = aliado?.attributes?.Estado.map((s) => s.states);

          return selectedStates.some((state) => states.includes(state));
        });
        newP.aliados.data = aliadosData;
        return newP;
      });
      setPartners(newPartners);
    } else {
      setPartners(partnersRef.current);
    }
  }, [selectedStates]);

useEffect(() => {
  if (locale === "en") {

    const titleTranslations = {
      "Fundadores": "Founders",
      "Fundaciones": "Foundations",
      "Co-Presentador": "Co-presenter",
      "Aliados": "Partnerships",
      "Medios aliados": "Media allies"
    };
    
    // Create a new array with translated titles
    const localizedPartners = partnerstBlocks.map(p => {
      return {
        ...p,
        // If we have a translation, use it; otherwise keep the original
        Title: titleTranslations[p.Title] || p.Title
      };
    });
    
    setPartners(localizedPartners);
    partnersRef.current = localizedPartners;
  } else {
    // Use original data for default locale
    setPartners(partnerstBlocks);
    partnersRef.current = partnerstBlocks;
  }
}, [locale, partnerstBlocks]);
  return (
    <>
      <Head>
        <title>{localeTexts[locale].Aliados.navigationAliados}</title>
        <meta
          name="description"
          content="Ambulante - Gira de documentales"
        ></meta>
      </Head>
      <div className="amb-container ">
        <div className="flex items-center">
          <Text.Display className="hidden lg:block" as="h2">
            {localeTexts[locale].Aliados.title}
          </Text.Display>
          <Text.Headline className="lg:hidden" as="h2" size="lg">
            {localeTexts[locale].Aliados.title}&nbsp;
          </Text.Headline>
          <div className="grow"></div>
          <div className="flex gap-3">
            {!initiativesFiltersError && (
              <Filter
                name={localeTexts[locale].Aliados.programas}
                align="right"
                filters={filters}
                onChange={setInitiatives}
                selected={initiatives}
              />
            )}
            <Filter
              name={localeTexts[locale].Aliados.estado}
              align="right"
              filters={mexicanStates}
              onChange={setSelectedStates}
              selected={selectedStates}
            />
          </div>
        </div>

        <div className="mt-5 flex flex-wrap gap-2">
          {selectedStates.map((t, i) => (
            <div
              key={i}
              className="flex items-center rounded-full bg-neutral-100 px-3"
            >
              <Text.Body
                as="p"
                className="w-max text-neutral-900"
                key={t}
                size="lg"
              >
                &nbsp;
                {mexicanStates.find((s) => s.value === t).name}&nbsp;
              </Text.Body>&nbsp;
              <XIcon
                className="ml-2 flex h-4 w-4 cursor-pointer rounded-full hover:bg-black hover:text-white"
                onClick={() =>
                  setSelectedStates(
                    selectedStates.filter((state) => state !== t)
                  )
                }
              ></XIcon>
            </div>
          ))}

          {initiatives.map((t, i) => (
            <div
              key={i}
              className="flex items-center rounded-full bg-neutral-100 px-3"
            >
              <Text.Body
                as="p"
                className="w-max text-neutral-900"
                key={t}
                size="lg"
              >
                &nbsp;
                {filters.find((s) => s.value === t).name}&nbsp;
              </Text.Body>&nbsp;
              <XIcon
                className="ml-2 flex h-4 w-4 cursor-pointer rounded-full hover:bg-black hover:text-white"
                onClick={() =>
                  setInitiatives(
                    initiatives.filter((initiative) => initiative !== t)
                  )
                }
              ></XIcon>
            </div>
          ))}

          {(initiatives.length !== 0 || selectedStates.length !== 0) && (
            <Text.Link
              className=" font-extrabold"
              onClick={clearFilters}
              label={localeTexts[locale].Aliados.clearFilters}
            ></Text.Link>
          )}
        </div>

        {partners.length
          ? partners.map((p) =>
            p.aliados.data.length > 0 ? (
              <div key={p.Title} className="mt-12 space-y-3">
                <Text.Title as="h3" size="xl">
                    {p.Title}
                </Text.Title> 
                <div className="grid-cols-2 gap-4 md:grid md:grid-cols-3 lg:grid-cols-4  ">
                  {p.aliados.data?.map((sponsor) => (
                    <div
                      className="h-[100px] w-full"
                      key={sponsor.attributes.name}
                    >
                      <a
                        className="flex h-full items-center align-middle"
                        href={sponsor.attributes.website}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <img
                          src={getStrapiImage(sponsor.attributes.logo)}
                          alt={sponsor.attributes.name}
                          className="m-auto h-1/2 h-full w-full object-contain"
                        />
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            ) : null
          )
          : null}
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const { locale } = context.query;
  try {
    let query = qs.stringify({
      populate: {
        localizations: {
          populate:"*",
        },
        aliados_block: {
          populate: {
            localizations:{
              populate:"*",
            },
            aliados: {
              populate: {
                localizations:{
                  populate:"*",
                },
                logo: "*",
                Estado: "*",
                iniciativas: "*",
              },
            },
          },
        },
      },
    });

    const entry = await apiClient.get(`/api/aliado?${query}`);
    const partners = entry.data;
    return {
      props: {
        partnerstBlocks: partners.data.attributes.aliados_block,
        locale: locale || "es-MX",
      },
    };
  } catch (err) {
    return {
      props: {
        notFound: true,
      },
    };
  }
}

Aliados.getLayout = function getLayout(page) {
  return (
    <div>
      <div className="mb-10 border-b border-gray-300 bg-white">
        <div className="amb-container">
          <Nav className="grow bg-gray-100" theme="light" />
        </div>
      </div>
      <div className="">{page}</div>
    </div>
  );
};
